import { NOTE_KEY_PREFIX, STORAGE_KEYS } from '@/components/emotion-detector/constants';

/**
 * Generates a note key for a journal entry
 */
export function getNoteKey(entryId: string): string {
	return `${NOTE_KEY_PREFIX}${entryId}`;
}

/**
 * Retrieves notes from localStorage
 */
export function getNotesFromStorage(): Record<string, string> {
	try {
		const stored = localStorage.getItem(STORAGE_KEYS.EMOTION_NOTES);
		if (!stored) {
			return {};
		}
		const parsed = JSON.parse(stored);
		// Ensure we return an object, not null or other types
		if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
			return {};
		}
		return parsed;
	} catch {
		return {};
	}
}

/**
 * Saves notes to localStorage
 */
export function saveNotesToStorage(notes: Record<string, string>): void {
	try {
		localStorage.setItem(STORAGE_KEYS.EMOTION_NOTES, JSON.stringify(notes));
	} catch {
		// Silently fail if localStorage is unavailable
	}
}
